import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import AppRoutes from './app-routes';
import { AuthenticatedGuard } from './authenticated.guard';
import { AutherizedGuard } from './autherized.guard';
import { ChangeoverComponent } from './changeover/changeover.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { LandingComponent } from './landing/landing.component';
import { LineSetupComponent } from './line-setup/line-setup.component';
import { NotProductionGuard } from './not-production.guard';
import { ResetDBComponent } from './reset-db/reset-db.component';
import { ReviewComponent } from './review/review.component';
import { AddComponent } from './schedule/add/add.component';
import { ScheduleComponent } from './schedule/schedule.component';

const routes: Routes = [
  { path: AppRoutes.Landing, component: LandingComponent },
  { path: AppRoutes.Changeover, component: ChangeoverComponent, canActivate: [AuthenticatedGuard] },
  { path: AppRoutes.ChangeoverReview, component: ReviewComponent, canActivate: [AuthenticatedGuard] },
  { path: AppRoutes.LineSchedule, component: ScheduleComponent, canActivate: [AuthenticatedGuard] },
  { path: AppRoutes.LineScheduleAdd, component: AddComponent, canActivate: [AuthenticatedGuard] },
  { path: AppRoutes.LineSetup, component: LineSetupComponent, canActivate: [AuthenticatedGuard] },
  { path: AppRoutes.ResetDB, component: ResetDBComponent, canActivate: [AuthenticatedGuard, NotProductionGuard] },
  {path:AppRoutes.Downloads,component:DownloadsComponent,canActivate:[AuthenticatedGuard,AutherizedGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
